var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 1.78125C13.0312 0.90625 14.4375 0.90625 15.3125 1.78125L15.7188 2.1875C16.5938 3.0625 16.5938 4.46875 15.7188 5.34375L9.53125 11.5312C9.28125 11.7812 8.9375 12 8.5625 12.0938L5.4375 13C5.1875 13.0625 4.90625 13 4.71875 12.7812C4.5 12.5938 4.4375 12.3125 4.5 12.0625L5.40625 8.9375C5.5 8.5625 5.71875 8.21875 5.96875 7.96875L12.1562 1.78125ZM14.25 2.84375C13.9688 2.5625 13.5 2.5625 13.2188 2.84375L12.2812 3.75L13.75 5.21875L14.6562 4.28125C14.9375 4 14.9375 3.53125 14.6562 3.25L14.25 2.84375ZM6.84375 9.34375L6.3125 11.1875L8.15625 10.6562C8.28125 10.625 8.375 10.5625 8.46875 10.4688L12.6875 6.25L11.25 4.8125L7.03125 9.03125C6.9375 9.125 6.875 9.21875 6.84375 9.34375ZM6.75 3C7.15625 3 7.5 3.34375 7.5 3.75C7.5 4.1875 7.15625 4.5 6.75 4.5H3.25C2.53125 4.5 2 5.0625 2 5.75V14.25C2 14.9688 2.53125 15.5 3.25 15.5H11.75C12.4375 15.5 13 14.9688 13 14.25V10.75C13 10.3438 13.3125 10 13.75 10C14.1562 10 14.5 10.3438 14.5 10.75V14.25C14.5 15.7812 13.25 17 11.75 17H3.25C1.71875 17 0.5 15.7812 0.5 14.25V5.75C0.5 4.25 1.71875 3 3.25 3H6.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.8363b69d03b37fd5f8a52168485fa6c2.svg";
export { ForwardRef as ReactComponent };